<template>
  <div class="el-col-24">
    <!-- 标题 -->
    <h5 class="warp-title">机器人管理</h5>
    <!-- 筛选 -->
    <el-form :model="searchForm" :inline="true" class="search" size="small">
      <el-form-item label="平台：">
        <el-select v-model="searchForm.platformType" placeholder="请选择显示" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option :label="item.name" :value="item.id" v-for="(item, index) in specialPlatformList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机器人内容">
        <el-input placeholder="请输入关键字" v-model="searchForm.content"></el-input>
      </el-form-item>
      <el-form-item label="内外部">
        <el-select v-model="searchForm.inOutFlag" placeholder="请选择显示">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="内部" :value="0"></el-option>
          <el-option label="外部" :value="1"></el-option>
          <el-option label="内外部" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问答分类" prop="typeId">
        <el-select v-model="searchForm.typeId" placeholder="请选择">
          <el-option label="全部" :value="-1"></el-option>
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.type"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="是否链接直接打开">
        <el-select v-model="searchForm.isHref" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="否" :value="0"></el-option>
          <el-option label="是" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="searchForm.problemFlag" :true-label="0" :false-label="-1">设置推荐</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" v-if="buttonPermission.robot_talk_query === 1" size="small" @click="onSearch" :loading="isSearchLoading">查询</el-button>
        <el-button type="primary" size="small" class="el-button" @click="toAdd" v-if="buttonPermission.robot_talk_add === 1"> 新增</el-button>
        <el-button size="small" class="el-button" @click="openPlatformSelect(1)" v-if="buttonPermission.robot_talk_solr === 1" :loading="isManualLoad"> 手动触发加载</el-button>
        <el-button size="small" class="el-button" @click="openPlatformSelect(2)" v-if="buttonPermission.robot_talk_recommended_sort === 1" :loading="isSortLoading">编辑推荐排序</el-button>
        <el-button type="primary" v-if="buttonPermission.robot_talk_query === 1" size="small" @click="setVisible(1)">设置外部可见</el-button>
        <el-button type="primary" v-if="buttonPermission.robot_talk_query === 1" size="small" @click="setVisible(0)">设置内部可见</el-button>
        <el-button type="primary" v-if="buttonPermission.robot_talk_query === 1" size="small" @click="setVisible(2)">设置内外可见</el-button>
      </el-form-item>
    </el-form>
    <!-- 内容 -->
    <div class="content">
      <el-table :data="tableData" border class="el-table" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            <div>{{searchForm.pageSize*(searchForm.currentPage-1)+scope.$index+1}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="platformName" label="平台" align="center"></el-table-column>
        <el-table-column prop="inOutFlagName" label="内外部" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.inOutFlag === 0" class="red">内部</span>
            <span v-if="scope.row.inOutFlag === 1" class="blue">外部</span>
            <span v-if="scope.row.inOutFlag === 2" class="green">内外部</span>
          </template>
        </el-table-column>
        <el-table-column prop="typeName" label="一级分类" align="center"></el-table-column>
        <el-table-column prop="problem" label="二级分类" align="center"></el-table-column>
        <el-table-column label="机器人内容" align="center" width="250">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" placement="top">
              <div slot="content">
                <div v-html="scope.row.content" class="robot-content-box"></div>
              </div>
              <el-button class="tooltip-button preview-text-container">
                <div v-html="scope.row.content" class="robot-content"></div>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="链接直接打开" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isHref === 0">否</span>
            <span v-if="scope.row.isHref === 1">是</span>
          </template>
        </el-table-column>
        <el-table-column prop="resolvedNum" label="有帮助" align="center"></el-table-column>
        <el-table-column prop="unresolvedNum" label="没帮助" align="center"></el-table-column>
        <el-table-column prop="createUserName" label="添加人" align="center"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <div><el-link :underline="false" type="primary" @click="toEdit(scope.row.id)" v-if="buttonPermission.robot_talk_edit === 1">编辑</el-link></div>
            <div><el-link :underline="false" type="primary" @click="toDetail(scope.row.id)" v-if="buttonPermission.robot_talk_view === 1">查看</el-link></div>
            <div><el-link :underline="false" type="primary" @click="setRecommend(scope.row.id)" v-if="buttonPermission.robot_talk_recommend === 1 && scope.row.problemFlag !== 0 && (scope.row.inOutFlag === 1 || scope.row.inOutFlag === 2)">设置推荐</el-link></div>
            <div><el-link :underline="false" type="danger" @click="cancelRecommend(scope.row.id)" v-if="buttonPermission.robot_talk_recommend === 1 && scope.row.problemFlag === 0 && (scope.row.inOutFlag === 1 || scope.row.inOutFlag === 2)">取消推荐</el-link></div>
            <div><el-link :underline="false" type="primary" @click="setColor(scope.row.id)" v-if="buttonPermission.robot_talk_recommend === 1 && scope.row.problemFlag === 0 && scope.row.colorFlag  !== 0 && (scope.row.inOutFlag === 1 || scope.row.inOutFlag === 2)">设置颜色</el-link></div>
            <div><el-link :underline="false" type="primary" @click="cancelColor(scope.row.id)" v-if="buttonPermission.robot_talk_recommend === 1 && scope.row.problemFlag === 0 && scope.row.colorFlag  === 0 && (scope.row.inOutFlag === 1 || scope.row.inOutFlag === 2)">取消颜色</el-link></div>
            <div><el-link :underline="false" type="danger" @click="toDel(scope.row.id)"  v-if="buttonPermission.robot_talk_delete === 1">删除</el-link></div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页器 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      align="right"
      class="mt20"
      background>
    </el-pagination>
    <!-- 查看详情 -->
    <el-dialog :visible.sync="detailBox" width="50%" class="add-dialog" :close-on-click-modal="false">
      <div slot="title" class="title">
        <h2 class="warp-title">查看内容</h2>
      </div>
      <el-descriptions :column="1" border labelClassName="label-box">
        <el-descriptions-item label="内外部">{{addForm.inOutFlagName}}</el-descriptions-item>
        <el-descriptions-item label="一级分类">{{addForm.typeName}}</el-descriptions-item>
        <el-descriptions-item label="二级分类">{{addForm.problem}}</el-descriptions-item>
        <el-descriptions-item label="机器人内容">
          <div v-html="addForm.content"></div>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <!-- 排序 -->
    <el-dialog :visible.sync="sortBox" width="500px" class="add-dialog" :close-on-click-modal="false">
      <div slot="title" class="title">
        <h2 class="warp-title">当前排序</h2>
      </div>
      <div class="sort-warp">
        <h6>
          显示序号
          <span class="fr">共 {{sortList.length}} 条</span>
        </h6>
        <ul>
          <li v-for="(item, index) in sortList" :key="index">
            <el-input v-model.trim.number="item.recommendedNum"></el-input>
            {{item.problem}}
          </li>
        </ul>
        <div class="fr">
          <el-button size="small" @click="reset">重新排序</el-button>
          <el-button size="small" type="primary" @click="sumbitSort" :loading="isSortSubmitLoading">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="handleType === 1 ? '手动触发加载' : '编辑推荐排序'"
      :visible.sync="showPlatformSelect"
      width="30%"
      :before-close="handlePlatformSelectClose"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-select v-model="currentPlatformId" placeholder="选择平台">
        <el-option :label="item.name" :value="item.id" v-for="(item, index) in platformList" :key="index"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPlatformSelect = false">取 消</el-button>
        <el-button type="primary" @click="onSubmitPlatformSelect">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryButtonPermission, queryRobotTalkPage, getSelectProblemType, deleteRobotTalk, getProblemAndInsert, setRecommend, setColor, viewRobotTalk, queryRobotRecommendedList, robotRecommendedReSort, setInOutVisible } from '../../api/robotManage/index.js'
export default {
  name: 'TalkRobot',
  async created () {
    this.getButtonPermission()
    this.getSelectProblemList()
  },
  computed: {
    platformList () {
      return this.$store.state.Auth.platformList
    },
    specialPlatformList () {
      return this.$store.state.Auth.specialPlatformList
    }
  },
  data () {
    return {
      // 1:手动触发加载 2：编辑推荐排序
      handleType: 1,
      currentPlatformId: '',
      showPlatformSelect: false,
      isAddLoading: false,
      isSortSubmitLoading: false,
      isSortLoading: false,
      isManualLoad: false,
      isSearchLoading: false,
      searchForm: {
        platformType: '',
        content: '',
        inOutFlag: -1,
        currentPage: 1,
        pageSize: 10,
        typeId: -1,
        problemFlag: -1
      },
      total: 10,
      dialogTitle: '新增机器人问答',
      dialogVisible: false,
      detailBox: false,
      sortBox: false,
      // 按钮权限
      buttonPermission: {},
      addForm: {
        isHref: 0,
        inOutFlag: 0,
        content: '',
        problem: '',
        typeId: ''
      },
      options: [],
      tableData: [
      ],
      addFormRule: {
        inOutFlag: [
          {required: true, message: '请选择显示', trigger: 'blur'}
        ],
        typeId: [
          {required: true, message: '请选择问答分类', trigger: 'blur'}
        ],
        problem: [
          {required: true, message: '请填写完整', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请填写完整', trigger: 'blur'}
        ],
        isHref: [
          {required: true, message: '请选择是否连接跳转', trigger: 'blur'}
        ]
      },
      sortList: [],
      selectList: []
    }
  },
  watch: {
    dialogVisible (newVal) {
      if (!newVal) {
        this.addForm = {
          inOutFlag: 0,
          content: '',
          problem: '',
          typeId: '',
          isHref: 0
        }
        this.editor = window.UM.getEditor('editor', this.config)
        this.editor.setContent('')
        this.$refs['addForm'].resetFields()
      }
    }
  },
  methods: {
    onSubmitPlatformSelect () {
      if (!String(this.currentPlatformId)) {
        return this.$message.warning('请选择平台')
      }
      this.showPlatformSelect = false
      if (this.handleType === 1) {
        this.manualLoad()
      } else {
        this.openSort()
      }
    },
    handlePlatformSelectClose () {},
    // 设置内外部
    setVisible (inOutFlag) {
      if (this.selectList.length === 0) {
        this.$message.warning('请先勾引要设置的项!')
        return
      }
      let title = ''
      if (inOutFlag === 0) {
        title = '内部'
      } else if (inOutFlag === 1) {
        title = '外部'
      } else if (inOutFlag === 2) {
        title = '内外'
      }
      this.$confirm(`确定要将勾选的${this.selectList.length}项设置为 ${title}可见 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let robotIds = []
        this.selectList.forEach(item => {
          robotIds.push(item.id)
        })
        let data = {
          inOutFlag: inOutFlag,
          robotIds: robotIds
        }
        setInOutVisible(data).then(res => {
          if (res.data.resultCode === 0) {
            this.$message.success('设置成功！')
            this.initData()
          } else {
            this.$message.error(res.data.resultMessage)
          }
        })
      }).catch(() => {
      })
    },
    handleSelectionChange (val) {
      this.selectList = val
    },
    // 排序
    openSort () {
      let data = {
        platformId: this.currentPlatformId
      }
      this.isSortLoading = true
      queryRobotRecommendedList(data).then(info => {
        this.isSortLoading = false
        if (info.data.resultCode === 0) {
          this.sortList = info.data.resultData
          this.sortBox = true
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSortLoading = false
      })
    },
    reset () {
      this.sortList.forEach(ele => {
        ele.recommendedNum = ''
      })
    },
    sumbitSort () {
      let data = {
        list: this.sortList,
        platformId: this.currentPlatformId
      }
      this.isSortSubmitLoading = true
      robotRecommendedReSort(data).then(info => {
        if (info.data.resultCode === 0) {
          this.sortBox = false
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).finally(() => {
        this.isSortSubmitLoading = false
      })
    },
    // 新增
    toAdd () {
      this.$router.push({
        name: 'TalkRobotAdd'
      })
    },
    // 编辑
    toEdit (id) {
      this.$router.push({
        name: 'TalkRobotEdit',
        params: {
          id: id
        }
      })
    },
    // 查看
    toDetail (id) {
      this.detailBox = true
      viewRobotTalk({id: id}).then(res => {
        this.addForm = res.data.resultData
      })
    },
    // 删除机器人
    toDel (id) {
      this.$confirm('您确定要删除该条内容吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRobotTalk({id: id}).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功！'
          })
          this.initData()
        }).catch(() => {
        })
      })
    },
    // 获取按钮权限
    getButtonPermission () {
      queryButtonPermission({id: global.$sider}).then(res => {
        this.buttonPermission = res.data.resultData
      })
    },
    // 页容量改变时
    handleSizeChange (size) {
      this.searchForm.pageSize = size
      this.searchForm.currentPage = 1
      this.initData()
    },
    // 页码改变时
    handleCurrentChange (page) {
      this.searchForm.currentPage = page
      this.initData()
    },
    onSearch () {
      this.searchForm.currentPage = 1
      this.initData()
    },
    // 获取机器人列表
    initData () {
      this.isSearchLoading = true
      queryRobotTalkPage(this.searchForm).then(res => {
        this.tableData = res.data.resultData
        this.total = res.data.totalCount
      }).finally(() => {
        this.isSearchLoading = false
      })
    },
    // 获取问题分类下拉列表
    getSelectProblemList () {
      getSelectProblemType({platformId: 0}).then(res => {
        this.options = res.data.resultData
      })
    },
    openPlatformSelect (type) {
      this.currentPlatformId = ''
      this.handleType = type
      this.showPlatformSelect = true
    },
    // 手动触发加载
    manualLoad () {
      this.isManualLoad = true
      getProblemAndInsert({platformId: this.currentPlatformId}).then(res => {
        this.isManualLoad = false
        this.$message({
          showClose: true,
          message: '手动触发加载成功！',
          type: 'success'
        })
      }).catch(() => {
        this.isManualLoad = false
      })
    },
    // 设置推荐
    setRecommend (id) {
      this.$confirm('您确定将该问答设置为推荐吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setRecommend({platformId: 0, id: id}).then(res => {
          this.$message({
            type: 'success',
            message: '设置推荐成功！'
          })
          this.initData()
        })
      })
    },
    // 设置颜色
    setColor (id) {
      this.$confirm('您确定要设置颜色吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setColor({platformId: 0, id: id}).then(res => {
          this.$message({
            type: 'success',
            message: '设置颜色成功！'
          })
          this.initData()
        })
      })
    },
    // 取消颜色
    cancelColor (id) {
      this.$confirm('您确定要取消颜色吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setColor({platformId: 1, id: id}).then(res => {
          this.$message({
            type: 'success',
            message: '取消颜色成功！'
          })
          this.initData()
        })
      })
    },
    // 取消推荐
    cancelRecommend (id) {
      this.$confirm('您确定取消推荐吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setRecommend({platformId: 0, id: id}).then(res => {
          this.$message({
            type: 'success',
            message: '取消推荐成功！'
          })
          this.initData()
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-tooltip.tooltip-button.preview-text-container{
  max-height: 130px;
  width: 100%;
  overflow-y: auto;
}
/deep/.cell img{
  width: 100%;
}
.answer-content{
  /deep/img{
    max-width: 100%;
  }
}
.add-dialog {
  .warp-title{
    margin: 0;
    margin-bottom: 20px;
  }
  /deep/ .el-dialog{
    padding: 20px;
    // max-height: 700px;
    padding: 40px;
  }
  /deep/ .el-dialog__body{
    padding: 0;
  }
  /deep/ .el-dialog__header{
    padding: 0;
  }
}
/deep/.el-textarea .el-input__count{
  bottom: -6px;
  right: 14px;
  background-color: transparent;
}
/deep/tr.el-table__row td{
  text-align: center;
}
/deep/thead.has-gutter tr th{
  text-align: center;
}
.tooltip-button{
  border: none;
}
.tooltip-button:hover{
  background-color: transparent;
  color: #333;
}
/deep/ .cell span{
  // width: 180px;
  display: inline-block;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  white-space: pre-wrap;
  line-height: 23px;
}
.add-dialog{
  .el-table{
    width: 100%;
    tr td:first-child{
      width: 200px;
    }
    tr td .cell{
      max-height: 300px;
      overflow-y: auto;
    }
  }
}
.sort-warp{
  width: 100%;
  display: table;
  h6{
    margin-bottom: 10px;
    font-weight: bolder;
    span{
      font-weight: 400;
    }
  }
  ul{
    max-height: 400px;
    overflow: hidden;
    overflow-y: auto;
    margin-bottom: 10px;
  }
  li{
    margin-bottom: 10px;
    line-height: 28px;
  }
  .el-input{
    width: 40px;
    margin-right: 5px;
  }
}
/deep/.label-box{
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/Robot/TalkRobot.vue